<ng-container *ngIf="isAzureAdEnable === false">
  <div class="login-container">
    <form
      action="#"
      class="login-form"
      (submit)="login($event, loginForm)"
      #loginForm="ngForm"
    >
      <h1>Temp Login</h1>
      <div class="login-form-body">
        <div class="p-fluid">
          <div class="p-field p-my-0">
            <label for="userAccount">User No.</label>
            <input
              id="userAccount"
              name="userAccount"
              type="text"
              autocomplete="off"
              placeholder="Please enter user no."
              pInputText
              [(ngModel)]="loginFormModel.userAccount"
              [required]="true"
              #userNoDom="ngModel"
            />
            <small
              class="p-error"
              *ngIf="
                userNoDom.invalid &&
                (userNoDom.dirty || userNoDom.touched) &&
                userNoDom.errors?.required
              "
            >
              This is required field
            </small>
          </div>
        </div>
      </div>
      <div class="p-text-center">
        <button
          pButton
          type="submit"
          label="Login"
          class="p-content-button"
          [disabled]="!loginForm.form.valid"
        ></button>
      </div>
    </form>
  </div>

</ng-container>
<p-toast position="top-right"></p-toast>
